import { collection, get, all, update, query, where } from "typesaurus"
import { GeoState, GroupType, AccountType } from "../types"

export interface CourseType {
  id: string
  created: number
  authorId: string
  displayName: string
  lastModified: number
  licenses: any[]
  name: string
  node: string
  published: boolean
  subcourses: string[]
}

const collection_ref = collection<CourseType>("courses")

export const getCourseById = (id: string) => {
  return get(collection_ref, id)
}

export const getCourseByName = (name: string) => {
  return query(collection_ref, [where("name", "==", name)])
}

export const getAllCourses = () => {
  return all(collection_ref)
}

export const updateCourseById = (id: string, newVals: Partial<CourseType>) => {
  return update(collection_ref, id, newVals)
}
